import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PhoneMissed } from "lucide-react";

const MESSAGES = [
  { kind: "event", text: "Missed call 2:14pm" },
  {
    kind: "out",
    text: "Hey, this is [Your Company], sorry we missed you! What can we help with?",
    time: "2:14pm",
  },
  { kind: "in", text: "Leak under my kitchen sink", time: "2:15pm" },
  {
    kind: "out",
    text: "Got it — grab a time here: [booking link]",
    time: "2:16pm",
  },
];

export default function PhoneMockup() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [30, -50]);

  return (
    <motion.div
      ref={ref}
      style={{ y }}
      className="flex flex-col items-center"
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
      <div
        data-testid="phone-mockup-example-label"
        className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-slate-200"
      >
        Example — not a real customer
      </div>

      <div
        data-testid="phone-mockup-sms-thread"
        className="animate-float-y w-[290px] rounded-[44px] border-8 border-[#0F172A] bg-[#0F172A] shadow-2xl shadow-black/40 sm:w-[320px]"
      >
        <div className="relative overflow-hidden rounded-[36px] bg-[#F1F5F9]">
          <div className="flex items-center gap-3 bg-white px-4 pb-3 pt-5">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-navy font-display text-sm font-extrabold text-white">
              W
            </div>
            <div>
              <p className="font-display text-sm font-bold text-ink">
                Your Company
              </p>
              <p className="text-[11px] text-slate-400">Business line</p>
            </div>
          </div>

          <div className="h-[380px] space-y-2.5 overflow-hidden p-3">
            {MESSAGES.map((m, i) => {
              if (m.kind === "event") {
                return (
                  <div key={i} className="flex justify-center pt-1">
                    <span className="flex items-center gap-1.5 rounded-full bg-slate-200/80 px-3 py-1 text-[11px] font-medium text-slate-600">
                      <PhoneMissed
                        className="h-3 w-3 text-red-500"
                        aria-hidden="true"
                      />
                      {m.text}
                    </span>
                  </div>
                );
              }
              if (m.kind === "out") {
                return (
                  <div key={i} className="flex justify-end">
                    <div className="max-w-[82%] rounded-2xl rounded-br-md bg-[#2D8CFF] px-3.5 py-2.5 text-[13px] leading-snug text-white shadow-sm">
                      {m.text}
                      <span className="mt-1 block text-right text-[10px] text-white/70">
                        {m.time}
                      </span>
                    </div>
                  </div>
                );
              }
              return (
                <div key={i} className="flex justify-start">
                  <div className="max-w-[82%] rounded-2xl rounded-bl-md border border-slate-200 bg-white px-3.5 py-2.5 text-[13px] leading-snug text-slate-700 shadow-sm">
                    {m.text}
                    <span className="mt-1 block text-right text-[10px] text-slate-400">
                      {m.time}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex items-center gap-2 bg-[#F1F5F9] px-3 pb-5 pt-1">
            <div className="flex-1 rounded-full border border-slate-200 bg-white px-4 py-2.5 text-xs text-slate-400">
              Text message
            </div>
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#2D8CFF]">
              <svg viewBox="0 0 32 32" className="h-4 w-4" aria-hidden="true">
                <path d="M29 3 L3 14.5 L13 18.5 Z" fill="#FFFFFF" />
                <path d="M29 3 L13 18.5 L16.5 29 Z" fill="#BAE0FF" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
